import React, { Component } from "react";
import {
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  Input,
  Table,
  Button
} from "reactstrap";

import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import Select from "react-select";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import DatePicker from "react-datepicker";
import Collapsible from 'react-collapsible';
import "react-datepicker/dist/react-datepicker.css";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Moment from "react-moment";
import Pagination from "react-js-pagination";
import "react-confirm-alert/src/react-confirm-alert.css";

import OrderApproveListCfm from "./_OrderApproveListCfm"
import { BtnPermissions } from "../../lib/BtnPermissions"
import DisplayRecordText from "../controls/_DisplayRecordText"
import CheckboxTreeList from "../controls/_CheckboxTreeList";
import ButtonExt from '../controls/ButtonExt'
import TrangThaiView from './_TrangThaiView'

import { currentDate, parseDatetime } from "../../lib/common";

// Import actions
import * as orderActions from '../Order/actions'
import orderConstants from '../Order/constants'
import * as ordersConstant from './constants'
import * as ordersAction from './actions'
import { storedb } from "../../views/client/storedb";

class Orders extends Component {
  constructor(props) {
    super(props);

    let dbContext = storedb();
    this.state = {
      searchCondition: {
        startDate: currentDate().startOf('month'),
        endDate: currentDate(),
        trangThai: "",
        keyword: '',
        Nvkd: [],
        selectedOptionKhachHang: null,
        selectedOptionDaiLy: null,
        type: 1,
        page: 1,
        per_page: 20,
        khachHang: "",
        DaiLy: "",
      },
      preFix: 'orders-',
      store_id: dbContext.getStoreId(),
      kho_id: dbContext.getKhoId(),
      khoIds: dbContext.getKhoIds(),
      listNvkd: [],
      listKhachHang: [],
      listDaiLy: [],
      total_record: 0,
      total_amount: 0,
      total_ck: 0,
      total_ck_amount: 0,
      modalApproveList: false,
      itemsChecked: [],
    };

    this.addHoaDonClick = this.addHoaDonClick.bind(this);
  }
  checkTypeOrder = (callback) => {
    const params = this.props.match ? this.props.match.params : 1;
    if (params) {
      let { searchCondition } = this.state
      searchCondition.type = parseInt(params.type || 1)
      searchCondition.trangThai = parseInt(params.status)
      this.setState({ searchCondition }, callback)
    }
  }
  handleControlChange(name, e) {
    let { searchCondition } = this.state
    switch (name) {
      case "startDate":
        searchCondition.startDate = e
        break;
      case "endDate":
        searchCondition.endDate = e
        break;
      case "TrangThai":
        searchCondition.trangThai = e.target.value
        break;
      case "keyword":
        searchCondition.keyword = e.target.value
        break;
    }
    this.setState({ searchCondition });
  }
  handleKhachHangChange = e => {
    let { searchCondition } = this.state
    if (e) {
      searchCondition.selectedOptionKhachHang = e
      searchCondition.khachHang = e.value
      this.setState({
        searchCondition
      }, () => {
        this.fetchList(1, true)
      });
    }
  }
  noOptionsKhClick = (e) => {
    let { searchCondition } = this.state
    let isClear = true
    if (e) {
      if (!searchCondition.selectedOptionKhachHang) {
        // select assign cycle when it's already null
        isClear = false
      }
    }
    if (isClear) {
      searchCondition.selectedOptionKhachHang = null
      searchCondition.khachHang = ''
      this.setState({
        searchCondition
      });
    }
  }
  handleDaiLyChange = e => {
    let { searchCondition } = this.state
    if (e) {
      searchCondition.selectedOptionDaiLy = e
      searchCondition.DaiLy = e.value
      this.setState({
        searchCondition
      }, () => {
      })
    }
  }
  handlePageChange = pageNumber => {
    let { searchCondition } = this.state
    searchCondition.page = parseInt(pageNumber || 1);
    return this.setState({ searchCondition }, () => {
      this.fetchList(pageNumber, true)
    })
  }
  orderLinkDetails = (type, soHd) => {
    return `/order-view/${type}/${soHd}`
  }
  viewOrder = (e, soHd) => {
    e.preventDefault()
    const url = this.orderLinkDetails(this.state.searchCondition.type, soHd)
    this.props.history.push(url);
  };
  search = () => {
    if (this.props.orders.listRequesting) {
      return false;
    }

    let { searchCondition } = this.state
    searchCondition.page = 1
    return this.setState({ searchCondition }, () => {
      this.fetchList(1, true)
    });
  };
  getListNVKD() {
    const { ordersListNvRequest } = this.props
    const requestData =
    {
      store_id: this.state.store_id
    }
    const callBack = (data) => {
      this.setState({
        listNvkd: data
      });
    }
    return ordersListNvRequest(requestData, callBack)
  }
  getListKhachHang = (Nvkd) => {
    let qianlyid = 0
    if (Nvkd && Nvkd.length > 0) {
      qianlyid = Nvkd[0].value
    }

    const formData = {
      storeId: this.state.store_id,
      userId: qianlyid,
      typeOfOrder: this.state.searchCondition.type
    }
    return this.props.ordersKhachHangRequest(formData)
  }
  getListDaiLy = () => {
    const { ordersDaiLyRequest } = this.props
    const requestData =
    {
      store: this.state.store_id
    }
    return ordersDaiLyRequest(requestData)
  }
  buildSelectOptionNVKD(listNVKD) {
    var options = [];
    if (listNVKD && listNVKD.length > 0) {
      listNVKD.map((item) => { options.push({ value: item.Id, label: item.TenDayDu }) }
      );
    }
    return options;
  }
  buildSelectOptionKhachHang(listKH) {
    var options = [];
    if (listKH && listKH.length > 0) {
      listKH.map((item) => {
        options.push(
          {
            value: item.Id,
            label: `${item.Ten}/ ${item.Ma}`
          })
      }
      );
    }
    return options;
  }
  buildSelectOptionDaiLy(listDL) {
    var options = [];
    if (listDL && listDL.length > 0) {
      listDL.map((item) => { options.push({ value: item.Id, label: item.Ten }) }
      );
    }
    return options;
  }
  fetchList = (page, useCached) => {
    const { ordersListRequest } = this.props
    const { searchCondition } = this.state
    var khId = '';
    if (searchCondition.type == 2) {
      khId = searchCondition.DaiLy
    } else {
      khId = searchCondition.khachHang
    }
    const requestData =
    {
      store_id: this.state.store_id,
      type: searchCondition.type,
      quanLyId: this.getQuanLyIds(),
      khachHangId: khId,
      keyword: searchCondition.keyword,
      trangThai: searchCondition.trangThai,
      startDate: searchCondition.startDate.unix(),
      endDate: searchCondition.endDate.endOf('days').unix(),
      page: page || searchCondition.page,
      per_page: searchCondition.per_page,
      use_cached: useCached || false,
    }
    return ordersListRequest(requestData)
  }
  getQuanLyIds = () => {
    if (!this.state.searchCondition.Nvkd || this.state.searchCondition.Nvkd.length === 0) {
      return 0
    } else {
      return this.state.searchCondition.Nvkd[0].value
    }
  }
  exportPdf = () => {
    const orderIds = this.state.itemsChecked
    if (orderIds.length > 0) {
      const { ordersExportPdfRequest } = this.props
      const requestData = {
        order_id: orderIds.join()
      }
      const dialogSaveFile = (data) => {
        var dataFile = new Blob([data], {
          type: 'application/pdf'
        });

        //bỏ chọn checkbox in
        const checkboxes = document.querySelectorAll('.ck-print-order');
        checkboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            checkbox.click();
          }
        });

        //hiển thị pdf trên trình duyệt
        var fileURL = URL.createObjectURL(dataFile);
        var id = 'dlinkExportPdf';
        var link = document.getElementById(id);
        if (link == null) {
          var a = document.createElement('a');
          a.style = "display:none;";
          a.id = id;
          a.target = "_blank";
          document.body.appendChild(a);
          link = a;
        }
        link.href = fileURL;
        link.click();
      }
      return ordersExportPdfRequest(requestData, dialogSaveFile)
    }
  }
  exportXls = () => {
    const { ordersExportXlsRequest } = this.props
    const { searchCondition } = this.state
    var khId = '';
    if (searchCondition.type == 2) {
      khId = searchCondition.DaiLy
    } else {
      khId = searchCondition.khachHang
    }
    const requestData =
    {
      store_id: this.state.store_id,
      type: searchCondition.type,
      quanLyId: this.getQuanLyIds(),
      khachHangId: khId,
      keyword: searchCondition.keyword,
      trangThai: searchCondition.trangThai || '',
      startDate: searchCondition.startDate.unix(),
      endDate: searchCondition.endDate.endOf('days').unix(),
      page: 0,
      per_page: 0
    }
    const dialogSaveFile = (data) => {
      var dataFile = new Blob([data], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "ds_dathang.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    }
    return ordersExportXlsRequest(requestData, dialogSaveFile)
  }
  onChangeItem = (itemPerPage) => {
    let { searchCondition } = this.state
    searchCondition.per_page = itemPerPage
    this.setState({ searchCondition }, () => {
      this.search();
    });
  }
  storeSearchCondition = () => {
    let { preFix, searchCondition } = this.state
    const key = `${preFix}${searchCondition.type}`
    let cached = JSON.stringify(searchCondition)
    sessionStorage.setItem(key, cached)
  }
  mergeSearchCondition = (type, callback) => {
    try {
      let { preFix, searchCondition } = this.state
      const key = `${preFix}${type}`
      const cached = sessionStorage.getItem(key)
      if (cached || cached != '') {
        let searchConditionCached = JSON.parse(cached)
        if (searchConditionCached) {
          searchCondition = { ...searchCondition, ...searchConditionCached }
          searchCondition.startDate = parseDatetime(searchCondition.startDate)
          searchCondition.endDate = parseDatetime(searchCondition.endDate)
        }
      }
      this.setState({ searchCondition }, callback)
    } catch (error) {
      callback()
    }
  }
  initData = () => {
    this.mergeSearchCondition(this.state.searchCondition.type, () => {
      if (this.state.searchCondition.type == 2) {
        this.getListDaiLy()
      } else {
        this.getListNVKD()
      }
      this.fetchList(1, true)
    })
  }
  componentDidMount() {
    this.checkTypeOrder(this.initData)
  }
  componentWillUnmount() {
    this.storeSearchCondition()
  }
  componentWillReceiveProps(nextProps) {
    let { searchCondition } = this.state
    const { match: { params } } = nextProps
    if (params.status != this.props.match.params.status ||
      params.type != this.props.match.params.type) {
      searchCondition.trangThai = parseInt(params.status)
      searchCondition.type = parseInt(params.type || 1)
      this.setState({ searchCondition }, () => {
        this.initData()
      });
    }

    if (nextProps.orders.type == ordersConstant.ORDERS_LIST_SUCCESS) {
      let { list, item } = nextProps.orders;
      searchCondition.page = item.page
      searchCondition.per_page = item.per_page
      this.setState(
        {
          searchCondition,
          total_record: item.total_record || 0,
          total_amount: item.total_amount || 0,
          total_ck: item.total_ck || 0,
          total_ck_amount: item.total_ck_amount || 0,
          page: item.page,
          per_page: item.per_page,
          list: list
        }
      )
    }
    else if (nextProps.orders.type == ordersConstant.ORDERS_DAILY_SUCCESS) {
      let { list } = nextProps.orders;
      this.setState({
        listDaiLy: this.buildSelectOptionDaiLy(list)
      });
    }
    else if (nextProps.orders.type == ordersConstant.ORDERS_KHACHHANG_SUCCESS) {
      let { list } = nextProps.orders;
      this.setState({
        listKhachHang: this.buildSelectOptionKhachHang(list)
      });

    }
  }
  addHoaDonClick = () => {
    const params = this.props.match ? this.props.match.params : {};
    if (params) {
      const { type } = params;
      this.props.history.push(`/order/${type}`);
    }
  }
  processOrderClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Tiếp nhận xử lý đơn hàng <b className="text-danger">{item.MaDonHang}</b> này không?
            </p>
            <button className="text-danger" onClick={() => {
              const formData = {
                store_id: item.StoreId,
                order_id: item.Id
              }
              const onSuccess = () => {
                setTimeout(this.fetchList, 1000)
              }
              this.props.processOrder(formData, onSuccess)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  // hoàn thành danh sach đơn hàng, đơn hàng sẽ chuyển sang trạng thái hoàn thành
  toggleApprove = e => {
    if (!this.state.modalApproveList) {
      this.setState(() => ({
        modalApproveList: true,
      }));
    }
    else {
      //close 
      this.setState(() => ({
        modalApproveList: false,
      }));
      this.props.setApproveError("")
      this.props.setApproveMessage("")
    }
  }
  approveOrdersClick = (approveInfor, ordersChecked) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Xác nhận xử lý hoàn thành cho danh sách đơn?
            </p>
            <button className="text-danger" onClick={() => {
              const orderIds = ordersChecked.map((item) => { return item.Id })
              const storeId = this.state.store_id
              const formData = {
                store_id: storeId,
                order_id: orderIds,
                ghi_chu: approveInfor.ghi_chu,
                da_thanh_toan: approveInfor.da_thanh_toan,
                noi_xuat: approveInfor.noi_xuat,
                is_approve_list: true,
              }
              const callSuccess = () => {
                setTimeout(() => {
                  this.fetchList()
                  this.toggleApprove()
                }, 1000)
              }
              this.props.postApproveOrders(formData, callSuccess)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  chkApproveCLick = (item, isChecked) => {
    let orders = this.props.orders.ordersApproveChecked
    const order = { Id: item.Id, MaDonHang: item.MaDonHang }
    const index = orders.findIndex(x => x.Id === order.Id)
    if (isChecked) {
      // add item to array
      if (index === -1) {
        orders.push(order)
      } else {
        orders[index] = order
      }
    } else {
      if (index > -1) {
        orders.splice(index, 1)
      }
    }
    this.props.setOrdersApproveList(orders)
  }
  onHandleRemove = () => {
    let { searchCondition } = this.state
    searchCondition.Nvkd = []
    this.setState({ searchCondition })
  }
  onHandleChoice = (nodesChecked) => {
    let { searchCondition } = this.state
    searchCondition.Nvkd = nodesChecked
    this.getListKhachHang(nodesChecked)
    this.setState({ searchCondition })
  }
  itemChecked = ({ target }) => {
    let { itemsChecked } = this.state
    const value = target.value
    if (target.checked) {
      const index = itemsChecked.indexOf(value)
      if (index === -1) {
        itemsChecked.push(value)
      }
    } else {
      const index = itemsChecked.indexOf(value)
      if (index > -1) {
        itemsChecked.splice(index, 1)
      }
    }
    this.setState({ itemsChecked })
  }
  render() {
    const {
      list,
      khoIds,
      searchCondition,
    } = this.state
    const {
      orders: {
        listRequesting,
        requesting,
        ordersApproveChecked
      },
    } = this.props
    const { type } = searchCondition
    const isAvailableApprove = () => {
      return ordersApproveChecked.length > 0
    }
    const startIndex = (searchCondition.page > 0 ? searchCondition.page - 1 : 0) * searchCondition.per_page
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting}>
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row>
                <Col sm="4" xs="6" md="2" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <DatePicker
                      name="startDate"
                      dateFormat="DD/MM/YYYY"
                      placeholderText="Từ ngày"
                      selected={searchCondition.startDate}
                      onChange={this.handleControlChange.bind(
                        this,
                        "startDate"
                      )}
                      required
                      className={"form-control"}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" xs="6" md="2" className="mb-1  pl-2 pr-2">
                  <InputGroup size="md">
                    <DatePicker
                      name="endDate"
                      dateFormat="DD/MM/YYYY"
                      placeholderText="Đến ngày"
                      selected={searchCondition.endDate}
                      popperClassName="react-end-date"
                      popperPlacement="top-end"
                      onChange={this.handleControlChange.bind(
                        this,
                        "endDate"
                      )}
                      required
                      className={"form-control"}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                {type == 2 &&
                  <Col sm="4" xs="12" md="4" className="mb-1 pl-2 pr-2">
                    <Select
                      placeholder="Chọn đại lý"
                      value={searchCondition.selectedOptionDaiLy}
                      onChange={this.handleDaiLyChange}
                      options={this.state.listDaiLy}
                      isClearable={true}
                    />
                  </Col>
                }
                {type == 1 &&
                  <Col sm="4" xs="12" md="4" className="mb-1 pl-2 pr-2">
                    <CheckboxTreeList
                      placeholder={`--Nhân viên KD--`}
                      nodes={this.state.listNvkd}
                      checked={searchCondition.Nvkd}
                      isMultiChoice={false}
                      onHandleRemove={(item) => this.onHandleRemove(item)}
                      onChoice={e => this.onHandleChoice(e)}
                    />
                  </Col>}
                {type == 1 &&
                  <Col sm="4" xs="12" md="4" className="mb-1 pl-2 pr-2">
                    <Select
                      placeholder="Chọn khách hàng"
                      value={searchCondition.selectedOptionKhachHang}
                      onChange={this.handleKhachHangChange}
                      options={this.state.listKhachHang}
                      isClearable={true}
                      noOptionsMessage={(e) => this.noOptionsKhClick(e)}
                    />
                  </Col>}
                <Col sm="4" xs="12" md="4" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off">
                      Hóa đơn
                    </InputGroupAddon>
                    <Input
                      name="keyword"
                      placeholder="Mã hóa đơn"
                      value={searchCondition.keyword}
                      onChange={this.handleControlChange.bind(
                        this,
                        "keyword"
                      )}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" xs="12" md="4" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <select
                      className="form-control"
                      value={searchCondition.trangThai || ''}
                      onChange={this.handleControlChange.bind(this, "TrangThai")}
                    >
                      <option value="">Trạng thái đơn</option>
                      {type == orderConstants.TYPEOF_ORDER.FOR_DEFAULT && (
                        <option value={0}>Đơn tạm</option>
                      )}
                      <option value={1}>Chờ xử lý</option>
                      <option value={2}>Đang xử lý</option>
                      <option value={10}>Hoàn thành</option>
                      <option value={99}>Hủy</option>
                    </select>
                  </InputGroup>
                </Col>

              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="mr-1 pull-left" onClick={this.search}>
                <i className="fa fa-search" /> Tìm kiếm
              </Button>
              <ButtonExt size="md" btnClass="pull-left mr-1 mb-1" btnClick={this.exportXls}
                iconClass="fa-file-excel-o" displayText="Xuất excel" color="success"
                permission={BtnPermissions.DonHang.EXPORT_ORDERS_EXCEL} />
              <ButtonExt size="md" btnClass="pull-left mr-1 mb-1" btnClick={this.addHoaDonClick}
                iconClass="fa-plus" displayText="Thêm đơn" color="primary"
                permission={BtnPermissions.DonHang.SAVE_ORDER} />
              <ButtonExt isDisabled={!isAvailableApprove()} size="md" btnClass="pull-left mr-1 mb-1" btnClick={this.toggleApprove}
                iconClass="fa-check" displayText="Hoàn thành" color="primary"
                permission={BtnPermissions.DonHang.APPROVE_ORDER} />
              <ButtonExt size="md" btnClass="pull-left mr-1 mb-1" btnClick={this.exportPdf}
                iconClass="fa-print" displayText="In đơn" color="success" />
              <div className="clearfix"></div>
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="30" className="text-center table-border-right">#</th>
                    <th scope="col" width="30" className="text-center table-border-right">In</th>
                    <th scope="col" width="150" className="text-center table-border-right">Mã đơn hàng</th>
                    <th scope="col" className="text-left table-border-right">Khách Hàng</th>
                    <th scope="col" width="100" className="text-center table-border-right">Ngày lập</th>
                    <th scope="col" width="120" className="text-center table-border-right">Nhân viên KD</th>
                    <th scope="col" width="110" className="text-center table-border-right">Nơi xuất</th>
                    <th scope="col" width="50" className="text-right table-border-right">Điểm</th>
                    <th scope="col" width="100" className="text-right table-border-right">Tổng tiền	</th>
                    <th scope="col" width="100" className="text-right table-border-right">Chiết khấu	</th>
                    <th scope="col" width="100" className="text-right table-border-right">Doanh số	</th>
                    <th scope="col" width="100" className="text-center table-border-right">Ghi chú</th>
                    <th scope="col" width="60" className="text-center table-border-right">G/hàng</th>
                    <th scope="col" width="100" className="text-center table-border-right">Trạng thái</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center table-border-right">{startIndex + (idx + 1)}</td>
                        <td className="text-center table-border-right">
                          { //Chỉ được in trạng thái đang xử lý đơn hàng trở đi
                            (res.TrangThai == 2 || res.TrangThai == 10) && <input type="checkbox" className="ck-print-order" value={res.Id} onChange={e => this.itemChecked(e)} />
                          }
                        </td>
                        <td className="text-left table-border-right">
                          <a href={`/#${this.orderLinkDetails(type, res.Id)}`} onClick={(e) => this.viewOrder(e, res.Id)}>{res.MaDonHang}</a>
                        </td>
                        <td className="text-left table-border-right">{res.TenKhachHang}</td>
                        <td className="text-center table-border-right">{res.NgayLap && <Moment format="HH:mm DD/MM">{`${res.NgayLap}`}</Moment>}</td>
                        <td className="text-center table-border-right">{res.TenNhanVien}</td>
                        <td className="text-center table-border-right">{res.NoiXuat}</td>
                        <td className="text-right text-success font-weight-bold table-border-right">{res.Diem}</td>
                        <td className="text-right text-danger font-weight-bold table-border-right">{parseFloat(res.TongTien || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right text-danger font-weight-bold table-border-right">{parseFloat(res.ChietKhau || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right text-danger font-weight-bold table-border-right">{parseFloat(res.ChietKhauDoanhSo || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-left table-border-right">{res.GhiChu}</td>
                        <td className="text-center table-border-right">{res.NgayGiao && <Moment format="DD/MM" tz="UTC">{`${res.NgayGiao}`}</Moment>}</td>
                        <td className="table-border-right text-center">
                          <TrangThaiView
                            order={res}
                            processOrderClick={this.processOrderClick}
                            chkApproveCLick={this.chkApproveCLick}
                            khoIds={khoIds}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="9" className="text-right">
                      Tổng Tiền:&nbsp;
                      <span className="text-success">
                        {this.state.total_amount &&
                          this.state.total_amount.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    <th scope="col" colSpan="1" className="text-right">
                      <span className="text-success">
                        {this.state.total_ck &&
                          this.state.total_ck.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    <th scope="col" colSpan="1" className="text-right">
                      <span className="text-success">
                        {this.state.total_ck_amount &&
                          this.state.total_ck_amount.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    <th scope="col" colSpan="3" className="text-right">
                    </th>
                  </tr>
                  <tr>
                    <td scope="col" colSpan="14" className="text-left">
                      <i className="text-info">
                        Chú ý: dơn tạm là đơn thuốc gửi nhà thuốc đã được nhà thuốc tiếp nhận và chờ phía công ty duyệt.
                      </i>
                    </td>
                  </tr>
                </tfoot>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <nav>
                  <Pagination
                    activePage={this.state.page}
                    itemsCountPerPage={this.state.per_page}
                    totalItemsCount={this.state.total_record}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                </nav>
              )}
            </div>
            <div className="clearfix"></div>
            <OrderApproveListCfm
              requesting={requesting}
              messages={this.props.orders.approvedMessages}
              errors={this.props.orders.approvedErrors}
              isApprove={this.state.modalApproveList}
              isAvailableApprove={isAvailableApprove}
              onClose={this.toggleApprove}
              approveOrdersClick={this.approveOrdersClick}
              ordersChecked={ordersApproveChecked}
            />
          </div>
        </BlockUi>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  orders: state.orders,
  client: state.client
});

const connected = connect(
  mapStateToProps,
  {
    ordersListRequest: ordersAction.ordersListRequest,
    ordersKhachHangRequest: ordersAction.ordersKhachHangRequest,
    ordersListNvRequest: ordersAction.ordersListNvRequest,
    ordersDaiLyRequest: ordersAction.ordersDaiLyRequest,
    ordersExportXlsRequest: ordersAction.ordersExportXlsRequest,
    ordersExportPdfRequest: ordersAction.ordersExportPdfRequest,
    setOrdersApproveList: ordersAction.setOrdersApproveList,
    postApproveOrders: ordersAction.postApproveOrders,
    setApproveError: ordersAction.setApproveError,
    setApproveMessage: ordersAction.setApproveMessage,
    setCallbackFunc: orderActions.setCallbackFunc,
    processOrder: orderActions.processOrder,
  }
)(Orders);

const formed = reduxForm({
  form: "orders"
})(connected);

export default formed;



// WEBPACK FOOTER //
// ./src/views/Orders/Orders.js